export default __webpack_public_path__ + "static/media/tzFavicon.10a4acde.png";